module.exports = {
  title: 'Center Justified', // Required
  author: 'Keith Center', // Required
  description: 'React && Ruby On Rails',
  primaryColor: '#3498db', // Required
  showHeaderImage: true,
  showShareButtons: true,
  postsPerPage: 5, // Required
  social: {
    website: 'http://www.centerjustified.com',
    github: 'https://github.com/centerjustified',
    twitter: 'https://twitter.com/centerjustified',
    linkedin: 'https://ca.linkedin.com/in/keith-center',
  },
  pathPrefix: '/devblog',
  siteUrl: 'https://centerjustified.gitlab.com/devblog/',
};
